<script setup>
import Buttons from '@/components/ui/Buttons.vue';
import CarList from '@/components/CarList.vue';
import { useBlockSafe } from '@/composables/useBlockSafe';

const props = defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
  isStock: {
    type: Boolean,
    default: false,
  },
});
const {
  id,
  backgroundColor,
  spacingTop,
  spacingBottom,
  title,
  items,
  buttons,
  hasTitle,
  hasItems,
  hasButtons,
  hasAnyContent,
} = useBlockSafe(props.data);
</script>
<template>
  <section
    v-if="hasAnyContent"
    :id="id"
    class="section"
    :class="[
      backgroundColor ? `bg-${backgroundColor}` : '',
      spacingTop ? `section--top-${spacingTop}` : 'section--top-xl',
      spacingBottom ? `section--bottom-${spacingBottom}` : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="cars">
        <h2
          v-if="hasTitle"
          class="mb-0 cars__title h2 black text-center"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="title"
        ></h2>
        <CarList
          v-if="hasItems"
          :items="items"
          :background-color="backgroundColor"
          :is-stock="isStock"
        />
        <Buttons
          v-if="hasButtons"
          class="cars__buttons"
          :buttons="buttons"
          :background-color="data?.background_color"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          :buttons-prefix-class="'js-button-cars'"
        />
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
.cars {
  display: flex;
  flex-direction: column;
  gap: 56px;
  @include media-breakpoint-up(sm) {
    gap: 80px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 80);
  }
  &__title {
    margin: 0;
  }
  &__buttons {
    justify-content: center;
  }
}
</style>
